import { render, staticRenderFns } from "./CustomerAnalysis.vue?vue&type=template&id=bc7513ec&scoped=true"
import script from "./CustomerAnalysis.vue?vue&type=script&lang=js"
export * from "./CustomerAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CustomerAnalysis.vue?vue&type=style&index=0&id=bc7513ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7513ec",
  null
  
)

export default component.exports